import { useQuery } from "@tanstack/react-query";
import { meApi, meQueryKeys } from "../api/me";

/**
 * Quyền của người đang đăng nhập, đọc từ `/v1/me` — cùng query key với Sidebar nên không gọi thêm
 * request nào (#19850).
 *
 * `loaded = false` khi chưa có câu trả lời: nơi gọi nên CHỜ thay vì vẽ lạc quan rồi rút lại, đúng
 * luật mà Sidebar đang dùng cho các mục có `requiresPermission`.
 */
export function usePermissions(): { loaded: boolean; has: (code: string) => boolean } {
  const profile = useQuery({
    queryKey: meQueryKeys.profile(),
    queryFn: () => meApi.get(),
    staleTime: 5 * 60_000,
  });
  const permissions = profile.data?.permissions ?? [];
  return { loaded: profile.isSuccess, has: (code) => permissions.includes(code) };
}
